import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Document, Packer, Paragraph, TextRun } from 'docx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})

export class ExcelService {
constructor( private datePipe: DatePipe) { }
public exportAsExcelFile(json: any[], excelFileName: string, sheetName: string = 'data'): void {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  const workbook: XLSX.WorkBook = { Sheets: { [sheetName]: worksheet }, SheetNames: [sheetName] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  this.saveAsExcelFile(excelBuffer, excelFileName);
}
private saveAsExcelFile(buffer: any, fileName: string): void {
   const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
   const date = this.datePipe.transform(new Date(), 'yyyy-MM-ddThh:mm:ss')
   let fileNameDate = fileName  + '_export_' + date +EXCEL_EXTENSION
   FileSaver.saveAs(data, fileNameDate);
}
downloadAsDocx(content: string , nSJobId :number) {
  console.log("downloadAsDocx :: starts");
  
  // const blob = new Blob([content], {
  //   type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  // });
  // const blob = new Blob([content], { type: 'text/plain' });
  // //saveAs(blob, 'example.txt');
  // const fileName = 'Summary.docx';
  // FileSaver.saveAs(blob, fileName);

    // Split the content into lines by newline character
    const lines = content.split(/\r?\n/);

    const paragraphs = lines.map(line =>
      new Paragraph({
        children: [new TextRun(line)],
      })
    );
  
    const doc = new Document({
      sections: [
        {
          children: paragraphs,
        },
      ],
    });

  Packer.toBlob(doc).then((blob) => {
    const fileName = `Summary_${nSJobId}.docx`;
    FileSaver.saveAs(blob, fileName);
  }).catch(error => {
    console.error("Failed to generate DOCX:", error);
  });
}
}